
      var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSelectedSongArt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 320,
  height: 320,
  viewBox: "0 0 320 320"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "selected-song-art_29390b5657c3bd3e__a",
  x1: 0,
  x2: 1,
  y1: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6b2a5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2b1430"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  rx: 12,
  fill: "url(#selected-song-art_29390b5657c3bd3e__a)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  opacity: 0.9,
  transform: "translate(40 40)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 32
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 28,
  width: 130,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 44,
  width: 90,
  height: 4,
  rx: 2
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"320\" height=\"320\" viewBox=\"0 0 320 320\">\r\n  <defs>\r\n    <linearGradient id=\"g\" x1=\"0\" x2=\"1\" y1=\"0\" y2=\"1\">\r\n      <stop offset=\"0\" stop-color=\"#6b2a5b\"/>\r\n      <stop offset=\"1\" stop-color=\"#2b1430\"/>\r\n    </linearGradient>\r\n  </defs>\r\n  <rect width=\"100%\" height=\"100%\" rx=\"12\" fill=\"url(#g)\" />\r\n  <g fill=\"#fff\" opacity=\"0.9\" transform=\"translate(40,40)\">\r\n    <circle cx=\"40\" cy=\"40\" r=\"32\" />\r\n    <rect x=\"90\" y=\"28\" width=\"130\" height=\"4\" rx=\"2\"/>\r\n    <rect x=\"90\" y=\"44\" width=\"90\" height=\"4\" rx=\"2\"/>\r\n  </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/selected-song-art.29390b5657c3bd3e2a1240d7638d9f76.svg"),
        {
          React: SvgSelectedSongArt,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      